import { persons as kycAcceptance } from '@repo/api-kit/kyc-acceptance';
import { IdentityVerificationStatus } from '@repo/api-kit/queries/due-diligence/kyc';

const { ApiIdnowProviderDetailsStatus } = kycAcceptance.firstparty.v1;

export function mapApStatusToLegacy(
  status?: (typeof IdentityVerificationStatus)[keyof typeof IdentityVerificationStatus],
  outcomeCode?: string
) {
  switch (outcomeCode) {
    case 'process_started':
      return ApiIdnowProviderDetailsStatus.on_call;
    case 'aborted':
      return ApiIdnowProviderDetailsStatus.failed;
    case 'cancelled':
    case 'cancelled_permanently':
      return ApiIdnowProviderDetailsStatus.canceled;
    case 'fraud_suspicion_pending':
    case 'review_pending':
      return ApiIdnowProviderDetailsStatus.waiting_results;
    case 'success':
    case 'accepted':
    case 'screening_rejected':
    case 'screening_missing':
    case 'outside_eu':
    case 'accepted_manually':
      return ApiIdnowProviderDetailsStatus.succeeded;
    case 'fraud_confirmed':
    case 'refused_manually':
      return ApiIdnowProviderDetailsStatus.rejected;
    case 'retry_requested_manually':
      return ApiIdnowProviderDetailsStatus.pending;
    case undefined:
    default:
      break;
  }

  switch (status) {
    case IdentityVerificationStatus.awaiting_result:
      return ApiIdnowProviderDetailsStatus.waiting_results;
    case IdentityVerificationStatus.completed:
      return ApiIdnowProviderDetailsStatus.succeeded;
    case IdentityVerificationStatus.in_progress:
    case IdentityVerificationStatus.pending:
    case IdentityVerificationStatus.STATUS_UNSPECIFIED:
    case undefined:
      return ApiIdnowProviderDetailsStatus.pending;
    default: {
      const exhaustiveCheck: never = status;
      return exhaustiveCheck;
    }
  }
}
